import React from 'react';
import { FormikRadioInput as Radio } from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';
import useSteps from '../StepContext/useSteps';
import { useFormikContext } from 'formik';
import { dietSettings } from '../types';

export const DietLevel: React.FC = () => {
  const { t } = useTranslator();
  const { dietLevels } = useSteps();
  const { values } = useFormikContext<dietSettings>();

  return (
    <>
      <h2 className="mb-4 title-large semi-bold">{t('app.goalSettings.dietLevel.headline')}</h2>

      {dietLevels.map((dietLevel) => {
        if (!dietLevel.renderCondition || dietLevel.renderCondition(values)) {
          return (
            <Radio name="dietLevel" value={dietLevel.value} key={dietLevel.id}>
              <strong>{t(dietLevel.optionTitle)}</strong>
              <p className="mb-0">{t(dietLevel.optionDescription)}</p>
            </Radio>
          );
        }
        return null;
      })}
    </>
  );
};

export default DietLevel;
